export function pad(n){ return n < 10 ? '0' + n : '' + n; }

export function formatDateByLang(dateInput, lang) {
  if (!dateInput) return '';
  const d = (dateInput instanceof Date) ? dateInput : new Date(dateInput);
  if (isNaN(d)) return '';

  const day = pad(d.getDate());
  const month = pad(d.getMonth() + 1);
  const year = d.getFullYear();

  const l = (lang || '').toLowerCase();

  if (l.startsWith('tr') || l.startsWith('de')) {
    return `${day}.${month}.${year}`; // DD.MM.YYYY
  }
  if (l.startsWith('en') || l.startsWith('fr')) {
    return `${day}/${month}/${year}`; // DD/MM/YYYY
  }

  return `${year}-${month}-${day}`;
}
 

